

















import { computed, defineComponent, PropType, useContext } from '@nuxtjs/composition-api';
import urlJoin from 'url-join';
import { useRuntimeConfig } from '~/composables/useRuntimeConfig';
import { COOKIE_KEY } from '~/constants';
import { url } from '~/utils';
import { sendLoginEvent as sendEvent } from '~/utils/ga';
import { LoginCategory, LoginStatus } from '~/enums/login';

const loginRakuten = require('~/assets/images/login/login_rakuten.png');

export default defineComponent({
  props: {
    scopes: {
      type: Array as PropType<string[]>,
      required: true,
    },
    buttonType: {
      type: String as PropType<'login' | 'cart'>,
      default: 'login',
    },
  },
  setup(props) {
    const {
      app: { $cookies },
    } = useContext();
    const { CONSOLS_API_ORIGIN, RAKUTEN_CLIENT_ID } = useRuntimeConfig();
    const clientId = computed(() => RAKUTEN_CLIENT_ID);
    const redirectUri = computed(() => urlJoin(CONSOLS_API_ORIGIN, '/callback/rakuten'));

    const formattedScope = computed(() => {
      return props.scopes.join(' ');
    });

    const onClickRakutenButton = () => {
      sendEvent(LoginStatus.TRIED, LoginCategory.RAKUTEN);
      localStorage.setItem('loginCategory', LoginCategory.RAKUTEN);
    };

    const submit = () => {
      $cookies.set(COOKIE_KEY.RAKUTEN_FROM, props.buttonType === 'login' ? url('AUTH_LOGIN') : url('SIGN_UP'));
      $cookies.set(COOKIE_KEY.IS_RAKUTEN_LOGIN, true, { path: '/' });
    };

    return {
      loginRakuten,
      clientId,
      redirectUri,
      formattedScope,
      submit,
      onClickRakutenButton,
    };
  },
});
